export default function PHP_date_parse() {
  return (
    <div>
      <h1>PHP_date_parse</h1>
    </div>
  );
}
